import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/Button";
import { Container } from "@/components/ui/Container";

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Container className="py-32 text-center">
      <h1 className="text-6xl font-bold text-white">404</h1>
      <p className="mt-4 text-slate-400">{t("errors.notFound")}</p>
      <Link to="/" className="inline-block mt-8">
        <Button>{t("nav.home")}</Button>
      </Link>
    </Container>
  );
}
